import React, { useState, useEffect } from "react";
import styles from "./css/LoginPage.module.css";
import { apiURL_BACKEND } from "./Vars";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
interface LoginPageProps {

}

const LoginPage: React.FC<LoginPageProps> = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError,setPasswordError] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        console.log("UserName:", username);
        console.log("Password:", password);
        axios.post(`${apiURL_BACKEND}/loginView/`, {
            username: username,
            password: password,
        }).then((response)=>{
            
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            setTimeout(() => {
                navigate("/dashboard/", { replace: true });
            }, 1500)
        }).catch((err)=>{
            setPasswordError(true);
            alert("Wrong username or password");
        });

    };
    const changeNavStyle = () => {
        document.documentElement.style.setProperty('--nav-text-color', 'black');
        document.documentElement.style.setProperty('--pseudo-nav-display', 'flex');
    };

    // const setAboutSelected = () => {

    //     document.getElementById('AboutUs')?.classList.add("selected");
    // }

    useEffect(() => {
        changeNavStyle();
        // setAboutSelected();
    }, [])

    const { isAuthenticated: isAuth, isLoading } = useAuth();
    useEffect(() => {
        if (isAuth) {
            navigate("/dashboard/")
        }
    }, [isAuth])
    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <h2 className={styles.title}>LOG-IN</h2>
                <form onSubmit={handleLogin} className={styles.form}>
                    <div>
                        <div className={styles.inputGroup}>
                            <input
                                type="text"
                                placeholder="Enter your username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                className={styles.input}
                            />
                            <span className={styles.icon}><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                <path d="M5 25C4.3125 25 3.72396 24.7552 3.23438 24.2656C2.74479 23.776 2.5 23.1875 2.5 22.5V7.5C2.5 6.8125 2.74479 6.22396 3.23438 5.73437C3.72396 5.24479 4.3125 5 5 5H25C25.6875 5 26.276 5.24479 26.7656 5.73437C27.2552 6.22396 27.5 6.8125 27.5 7.5V22.5C27.5 23.1875 27.2552 23.776 26.7656 24.2656C26.276 24.7552 25.6875 25 25 25H5ZM15 16.25L5 10V22.5H25V10L15 16.25ZM15 13.75L25 7.5H5L15 13.75ZM5 10V7.5V22.5V10Z" fill="#4AC558" />
                            </svg></span>
                        </div>
                        {
                            passwordError ? (<>
                            <div style={{ alignSelf: "flex-start",fontSize:"12px", textAlign: 'start', color: 'crimson',marginLeft: '5px' }}>Wrong username or password !</div>
                            </>):(<></>)
                        }
                        
                    </div>
                    <div>
                        <div className={styles.inputGroup}>
                            <input
                                type="password"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className={styles.input}
                            />
                            <span className={styles.icon}><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                <path d="M2.5 23.75V21.25H27.5V23.75H2.5ZM3.9375 16.1875L2.3125 15.25L3.375 13.375H1.25V11.5H3.375L2.3125 9.6875L3.9375 8.75L5 10.5625L6.0625 8.75L7.6875 9.6875L6.625 11.5H8.75V13.375H6.625L7.6875 15.25L6.0625 16.1875L5 14.3125L3.9375 16.1875ZM13.9375 16.1875L12.3125 15.25L13.375 13.375H11.25V11.5H13.375L12.3125 9.6875L13.9375 8.75L15 10.5625L16.0625 8.75L17.6875 9.6875L16.625 11.5H18.75V13.375H16.625L17.6875 15.25L16.0625 16.1875L15 14.3125L13.9375 16.1875ZM23.9375 16.1875L22.3125 15.25L23.375 13.375H21.25V11.5H23.375L22.3125 9.6875L23.9375 8.75L25 10.5625L26.0625 8.75L27.6875 9.6875L26.625 11.5H28.75V13.375H26.625L27.6875 15.25L26.0625 16.1875L25 14.3125L23.9375 16.1875Z" fill="#4AC558" />
                            </svg></span>
                        </div>
                        {
                            passwordError ? (<>
                            <div style={{ alignSelf: "flex-start",fontSize:"12px", textAlign: 'start', color: 'crimson', marginLeft: '5px' }}>Wrong username or password !</div>
                            </>):(<></>)
                        }
                    </div>

                    <a href="/signup/" className={styles.registerLink}>
                        Don’t have an account? Click to Register
                    </a>
                    <button type="submit" className={styles.button}>
                        Login
                    </button>
                </form>
                <svg className={styles.svg_style} xmlns="http://www.w3.org/2000/svg" height="82" viewBox="0 0 858 82" fill="none">
                    <path d="M0 0L858 82H21C9.40201 82 0 72.598 0 61V0Z" fill="#4AC558" />
                </svg>
            </div>

        </div>
    );
};

export default LoginPage;
